.kf{border-radius:0.375rem;}